import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/regenerator/index.js";
import $5yePs$react, { useRef as $5yePs$useRef, useState as $5yePs$useState, useEffect as $5yePs$useEffect, useCallback as $5yePs$useCallback } from "react";
import { useSSRSafeId as $5yePs$useSSRSafeId } from "@react-aria/ssr";
import $5yePs$clsx from "clsx";
import { clamp as $691ac3ad1af88e64$re_export$clamp, snapValueToStep as $691ac3ad1af88e64$re_export$snapValueToStep } from "@react-stately/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $5b01a7ee7dba2d86$exports = {};
$parcel$export($5b01a7ee7dba2d86$exports, "useId", function () {
  return $5b01a7ee7dba2d86$export$f680877a34711e37;
});
$parcel$export($5b01a7ee7dba2d86$exports, "mergeIds", function () {
  return $5b01a7ee7dba2d86$export$cd8c9cb68f842629;
});
$parcel$export($5b01a7ee7dba2d86$exports, "useSlotId", function () {
  return $5b01a7ee7dba2d86$export$b4cc09c592e8fdb8;
});
var $5ac25c9c8ba077b3$exports = {};
$parcel$export($5ac25c9c8ba077b3$exports, "useLayoutEffect", function () {
  return $5ac25c9c8ba077b3$export$e5c5a5f917a5871c;
});
var $5ac25c9c8ba077b3$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? $5yePs$react.useLayoutEffect : function () {};
var $5b01a7ee7dba2d86$var$idsUpdaterMap = new Map();

function $5b01a7ee7dba2d86$export$f680877a34711e37(defaultId) {
  var isRendering = $5yePs$useRef(true);
  isRendering.current = true;

  var _$5yePs$useState = $5yePs$useState(defaultId),
      _$5yePs$useState2 = _slicedToArray(_$5yePs$useState, 2),
      value = _$5yePs$useState2[0],
      setValue = _$5yePs$useState2[1];

  var nextId = $5yePs$useRef(null);
  var res = $5yePs$useSSRSafeId(value); // don't memo this, we want it new each render so that the Effects always run

  var updateValue = function updateValue(val) {
    if (!isRendering.current) setValue(val);else nextId.current = val;
  };

  $5b01a7ee7dba2d86$var$idsUpdaterMap.set(res, updateValue);
  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    isRendering.current = false;
  }, [updateValue]);
  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    var r = res;
    return function () {
      $5b01a7ee7dba2d86$var$idsUpdaterMap.delete(r);
    };
  }, [res]);
  $5yePs$useEffect(function () {
    var newId = nextId.current;

    if (newId) {
      setValue(newId);
      nextId.current = null;
    }
  }, [setValue, updateValue]);
  return res;
}

function $5b01a7ee7dba2d86$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  var setIdA = $5b01a7ee7dba2d86$var$idsUpdaterMap.get(idA);

  if (setIdA) {
    setIdA(idB);
    return idB;
  }

  var setIdB = $5b01a7ee7dba2d86$var$idsUpdaterMap.get(idB);

  if (setIdB) {
    setIdB(idA);
    return idA;
  }

  return idB;
}

function $5b01a7ee7dba2d86$export$b4cc09c592e8fdb8() {
  var depArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = $5b01a7ee7dba2d86$export$f680877a34711e37();

  var _$71eec9ddbfb7f6c6$ex = $71eec9ddbfb7f6c6$export$14d238f342723f25(id),
      _$71eec9ddbfb7f6c6$ex2 = _slicedToArray(_$71eec9ddbfb7f6c6$ex, 2),
      resolvedId = _$71eec9ddbfb7f6c6$ex2[0],
      setResolvedId = _$71eec9ddbfb7f6c6$ex2[1];

  var updateId = $5yePs$useCallback(function () {
    setResolvedId( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return id;

            case 2:
              _context.next = 4;
              return document.getElementById(id) ? id : null;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [id, setResolvedId]);
  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(updateId, [id, updateId].concat(_toConsumableArray(depArray)));
  return resolvedId;
}

var $2a5eca539fe56811$exports = {};
$parcel$export($2a5eca539fe56811$exports, "chain", function () {
  return $2a5eca539fe56811$export$e08e3b67e392101e;
});

function $2a5eca539fe56811$export$e08e3b67e392101e() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  return function () {
    var _iterator = _createForOfIteratorHelper(callbacks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var callback = _step.value;
        if (typeof callback === 'function') callback.apply(void 0, arguments);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}

var $c42fb2a2f22e1846$exports = {};
$parcel$export($c42fb2a2f22e1846$exports, "mergeProps", function () {
  return $c42fb2a2f22e1846$export$9d1611c77c2fe928;
});

function $c42fb2a2f22e1846$export$9d1611c77c2fe928() {
  // Start with a base clone of the first argument. This is a lot faster than starting
  // with an empty object and adding properties as we go.
  var result = _objectSpread({}, arguments.length <= 0 ? undefined : arguments[0]);

  for (var i = 1; i < arguments.length; i++) {
    var props = i < 0 || arguments.length <= i ? undefined : arguments[i];

    for (var key in props) {
      var a = result[key];
      var b = props[key]; // Chain events

      if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
      key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >=
      /* 'A' */
      65 && key.charCodeAt(2) <=
      /* 'Z' */
      90) result[key] = $2a5eca539fe56811$export$e08e3b67e392101e(a, b);else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = $5yePs$clsx(a, b);else if (key === 'id' && a && b) result.id = $5b01a7ee7dba2d86$export$cd8c9cb68f842629(a, b);else result[key] = b !== undefined ? b : a;
    }
  }

  return result;
}

var $f3859cd41d3e5b7d$exports = {};
$parcel$export($f3859cd41d3e5b7d$exports, "filterDOMProps", function () {
  return $f3859cd41d3e5b7d$export$457c3d6518dd4c6f;
});
var $f3859cd41d3e5b7d$var$DOMPropNames = new Set(['id']);
var $f3859cd41d3e5b7d$var$labelablePropNames = new Set(['aria-label', 'aria-labelledby', 'aria-describedby', 'aria-details']);
var $f3859cd41d3e5b7d$var$propRe = /^(data-.*)$/;

function $f3859cd41d3e5b7d$export$457c3d6518dd4c6f(props) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var labelable = opts.labelable,
      propNames = opts.propNames;
  var filteredProps = {};

  for (var prop in props) {
    if (Object.prototype.hasOwnProperty.call(props, prop) && ($f3859cd41d3e5b7d$var$DOMPropNames.has(prop) || labelable && $f3859cd41d3e5b7d$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $f3859cd41d3e5b7d$var$propRe.test(prop))) filteredProps[prop] = props[prop];
  }

  return filteredProps;
}

var $1b46e2787874cd75$exports = {};
$parcel$export($1b46e2787874cd75$exports, "focusWithoutScrolling", function () {
  return $1b46e2787874cd75$export$de79e2c695e052f3;
});

function $1b46e2787874cd75$export$de79e2c695e052f3(element) {
  if ($1b46e2787874cd75$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });else {
    var scrollableElements = $1b46e2787874cd75$var$getScrollableElements(element);
    element.focus();
    $1b46e2787874cd75$var$restoreScrollPosition(scrollableElements);
  }
}

var $1b46e2787874cd75$var$supportsPreventScrollCached = null;

function $1b46e2787874cd75$var$supportsPreventScroll() {
  if ($1b46e2787874cd75$var$supportsPreventScrollCached == null) {
    $1b46e2787874cd75$var$supportsPreventScrollCached = false;

    try {
      var focusElem = document.createElement('div');
      focusElem.focus({
        get preventScroll() {
          $1b46e2787874cd75$var$supportsPreventScrollCached = true;
          return true;
        }

      });
    } catch (e) {// Ignore
    }
  }

  return $1b46e2787874cd75$var$supportsPreventScrollCached;
}

function $1b46e2787874cd75$var$getScrollableElements(element) {
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = document.scrollingElement || document.documentElement;

  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }

  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}

function $1b46e2787874cd75$var$restoreScrollPosition(scrollableElements) {
  var _iterator2 = _createForOfIteratorHelper(scrollableElements),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _step2.value,
          element = _step2$value.element,
          scrollTop = _step2$value.scrollTop,
          scrollLeft = _step2$value.scrollLeft;
      element.scrollTop = scrollTop;
      element.scrollLeft = scrollLeft;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

var $fbd35a31e994df41$exports = {};
$parcel$export($fbd35a31e994df41$exports, "getOffset", function () {
  return $fbd35a31e994df41$export$622cea445a1c5b7d;
});

function $fbd35a31e994df41$export$622cea445a1c5b7d(element, reverse) {
  var orientation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'horizontal';
  var rect = element.getBoundingClientRect();
  if (reverse) return orientation === 'horizontal' ? rect.right : rect.bottom;
  return orientation === 'horizontal' ? rect.left : rect.top;
}

var $691ac3ad1af88e64$exports = {};
$parcel$export($691ac3ad1af88e64$exports, "clamp", function () {
  return $691ac3ad1af88e64$re_export$clamp;
});
$parcel$export($691ac3ad1af88e64$exports, "snapValueToStep", function () {
  return $691ac3ad1af88e64$re_export$snapValueToStep;
});
var $51de12ccb2f75a87$exports = {};
$parcel$export($51de12ccb2f75a87$exports, "runAfterTransition", function () {
  return $51de12ccb2f75a87$export$24490316f764c430;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.

var $51de12ccb2f75a87$var$transitionsByElement = new Map(); // A list of callbacks to call once there are no transitioning elements.

var $51de12ccb2f75a87$var$transitionCallbacks = new Set();

function $51de12ccb2f75a87$var$setupGlobalEvents() {
  if (typeof window === 'undefined') return;

  var onTransitionStart = function onTransitionStart(e) {
    // Add the transitioning property to the list for this element.
    var transitions = $51de12ccb2f75a87$var$transitionsByElement.get(e.target);

    if (!transitions) {
      transitions = new Set();
      $51de12ccb2f75a87$var$transitionsByElement.set(e.target, transitions); // The transitioncancel event must be registered on the element itself, rather than as a global
      // event. This enables us to handle when the node is deleted from the document while it is transitioning.
      // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.

      e.target.addEventListener('transitioncancel', onTransitionEnd);
    }

    transitions.add(e.propertyName);
  };

  var onTransitionEnd = function onTransitionEnd(e) {
    // Remove property from list of transitioning properties.
    var properties = $51de12ccb2f75a87$var$transitionsByElement.get(e.target);
    if (!properties) return;
    properties.delete(e.propertyName); // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.

    if (properties.size === 0) {
      e.target.removeEventListener('transitioncancel', onTransitionEnd);
      $51de12ccb2f75a87$var$transitionsByElement.delete(e.target);
    } // If no transitioning elements, call all of the queued callbacks.


    if ($51de12ccb2f75a87$var$transitionsByElement.size === 0) {
      var _iterator3 = _createForOfIteratorHelper($51de12ccb2f75a87$var$transitionCallbacks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var cb = _step3.value;
          cb();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      $51de12ccb2f75a87$var$transitionCallbacks.clear();
    }
  };

  document.body.addEventListener('transitionrun', onTransitionStart);
  document.body.addEventListener('transitionend', onTransitionEnd);
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') $51de12ccb2f75a87$var$setupGlobalEvents();else document.addEventListener('DOMContentLoaded', $51de12ccb2f75a87$var$setupGlobalEvents);
}

function $51de12ccb2f75a87$export$24490316f764c430(fn) {
  // Wait one frame to see if an animation starts, e.g. a transition on mount.
  requestAnimationFrame(function () {
    // If no transitions are running, call the function immediately.
    // Otherwise, add it to a list of callbacks to run at the end of the animation.
    if ($51de12ccb2f75a87$var$transitionsByElement.size === 0) fn();else $51de12ccb2f75a87$var$transitionCallbacks.add(fn);
  });
}

var $b8aeddd69b238bce$exports = {};
$parcel$export($b8aeddd69b238bce$exports, "useDrag1D", function () {
  return $b8aeddd69b238bce$export$7bbed75feba39706;
}); // Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.

var $b8aeddd69b238bce$var$draggingElements = [];

function $b8aeddd69b238bce$export$7bbed75feba39706(props) {
  console.warn('useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html');
  var containerRef = props.containerRef,
      reverse = props.reverse,
      orientation = props.orientation,
      onHover = props.onHover,
      onDrag = props.onDrag,
      onPositionChange = props.onPositionChange,
      onIncrement = props.onIncrement,
      onDecrement = props.onDecrement,
      onIncrementToMax = props.onIncrementToMax,
      onDecrementToMin = props.onDecrementToMin,
      onCollapseToggle = props.onCollapseToggle;

  var getPosition = function getPosition(e) {
    return orientation === 'horizontal' ? e.clientX : e.clientY;
  };

  var getNextOffset = function getNextOffset(e) {
    var containerOffset = $fbd35a31e994df41$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
    var mouseOffset = getPosition(e);
    var nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
    return nextOffset;
  };

  var dragging = $5yePs$useRef(false);
  var prevPosition = $5yePs$useRef(0); // Keep track of the current handlers in a ref so that the events can access them.

  var handlers = $5yePs$useRef({
    onPositionChange: onPositionChange,
    onDrag: onDrag
  });
  handlers.current.onDrag = onDrag;
  handlers.current.onPositionChange = onPositionChange;

  var onMouseDragged = function onMouseDragged(e) {
    e.preventDefault();
    var nextOffset = getNextOffset(e);

    if (!dragging.current) {
      dragging.current = true;
      if (handlers.current.onDrag) handlers.current.onDrag(true);
      if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
    }

    if (prevPosition.current === nextOffset) return;
    prevPosition.current = nextOffset;
    if (onPositionChange) onPositionChange(nextOffset);
  };

  var onMouseUp = function onMouseUp(e) {
    var target = e.target;
    dragging.current = false;
    var nextOffset = getNextOffset(e);
    if (handlers.current.onDrag) handlers.current.onDrag(false);
    if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
    $b8aeddd69b238bce$var$draggingElements.splice($b8aeddd69b238bce$var$draggingElements.indexOf(target), 1);
    window.removeEventListener('mouseup', onMouseUp, false);
    window.removeEventListener('mousemove', onMouseDragged, false);
  };

  var onMouseDown = function onMouseDown(e) {
    var target = e.currentTarget; // If we're already handling dragging on a descendant with useDrag1D, then
    // we don't want to handle the drag motion on this target as well.

    if ($b8aeddd69b238bce$var$draggingElements.some(function (elt) {
      return target.contains(elt);
    })) return;
    $b8aeddd69b238bce$var$draggingElements.push(target);
    window.addEventListener('mousemove', onMouseDragged, false);
    window.addEventListener('mouseup', onMouseUp, false);
  };

  var onMouseEnter = function onMouseEnter() {
    if (onHover) onHover(true);
  };

  var onMouseOut = function onMouseOut() {
    if (onHover) onHover(false);
  };

  var onKeyDown = function onKeyDown(e) {
    switch (e.key) {
      case 'Left':
      case 'ArrowLeft':
        if (orientation === 'horizontal') {
          e.preventDefault();
          if (onDecrement && !reverse) onDecrement();else if (onIncrement && reverse) onIncrement();
        }

        break;

      case 'Up':
      case 'ArrowUp':
        if (orientation === 'vertical') {
          e.preventDefault();
          if (onDecrement && !reverse) onDecrement();else if (onIncrement && reverse) onIncrement();
        }

        break;

      case 'Right':
      case 'ArrowRight':
        if (orientation === 'horizontal') {
          e.preventDefault();
          if (onIncrement && !reverse) onIncrement();else if (onDecrement && reverse) onDecrement();
        }

        break;

      case 'Down':
      case 'ArrowDown':
        if (orientation === 'vertical') {
          e.preventDefault();
          if (onIncrement && !reverse) onIncrement();else if (onDecrement && reverse) onDecrement();
        }

        break;

      case 'Home':
        e.preventDefault();
        if (onDecrementToMin) onDecrementToMin();
        break;

      case 'End':
        e.preventDefault();
        if (onIncrementToMax) onIncrementToMax();
        break;

      case 'Enter':
        e.preventDefault();
        if (onCollapseToggle) onCollapseToggle();
        break;
    }
  };

  return {
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseOut: onMouseOut,
    onKeyDown: onKeyDown
  };
}

var $ce924e419b398d4c$exports = {};
$parcel$export($ce924e419b398d4c$exports, "useGlobalListeners", function () {
  return $ce924e419b398d4c$export$4eaf04e54aa8eed6;
});

function $ce924e419b398d4c$export$4eaf04e54aa8eed6() {
  var globalListeners = $5yePs$useRef(new Map());
  var addGlobalListener = $5yePs$useCallback(function (eventTarget, type, listener, options) {
    // Make sure we remove the listener after it is called with the `once` option.
    var fn = (options === null || options === void 0 ? void 0 : options.once) ? function () {
      globalListeners.current.delete(listener);
      listener.apply(void 0, arguments);
    } : listener;
    globalListeners.current.set(listener, {
      type: type,
      eventTarget: eventTarget,
      fn: fn,
      options: options
    });
    eventTarget.addEventListener(type, listener, options);
  }, []);
  var removeGlobalListener = $5yePs$useCallback(function (eventTarget, type, listener, options) {
    var ref;
    var fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  var removeAllGlobalListeners = $5yePs$useCallback(function () {
    globalListeners.current.forEach(function (value, key) {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]); // eslint-disable-next-line arrow-body-style

  $5yePs$useEffect(function () {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener: addGlobalListener,
    removeGlobalListener: removeGlobalListener,
    removeAllGlobalListeners: removeAllGlobalListeners
  };
}

var $71a2c5844f2b60a4$exports = {};
$parcel$export($71a2c5844f2b60a4$exports, "useLabels", function () {
  return $71a2c5844f2b60a4$export$d6875122194c7b44;
});

function $71a2c5844f2b60a4$export$d6875122194c7b44(props, defaultLabel) {
  var id = props.id,
      label = props['aria-label'],
      labelledBy = props['aria-labelledby']; // If there is both an aria-label and aria-labelledby,
  // combine them by pointing to the element itself.

  id = $5b01a7ee7dba2d86$export$f680877a34711e37(id);

  if (labelledBy && label) {
    var ids = new Set([].concat(_toConsumableArray(labelledBy.trim().split(/\s+/)), [id]));
    labelledBy = _toConsumableArray(ids).join(' ');
  } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' '); // If no labels are provided, use the default


  if (!label && !labelledBy && defaultLabel) label = defaultLabel;
  return {
    id: id,
    'aria-label': label,
    'aria-labelledby': labelledBy
  };
}

var $a235e7a487a1e81a$exports = {};
$parcel$export($a235e7a487a1e81a$exports, "useObjectRef", function () {
  return $a235e7a487a1e81a$export$4338b53315abf666;
});

function $a235e7a487a1e81a$export$4338b53315abf666(forwardedRef) {
  var objRef = $5yePs$useRef();
  /**
  * We're using `useLayoutEffect` here instead of `useEffect` because we want
  * to make sure that the `ref` value is up to date before other places in the
  * the execution cycle try to read it.
  */

  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    if (!forwardedRef) return;
    if (typeof forwardedRef === 'function') forwardedRef(objRef.current);else forwardedRef.current = objRef.current;
  }, [forwardedRef]);
  return objRef;
}

var $2a91c3126c559388$exports = {};
$parcel$export($2a91c3126c559388$exports, "useUpdateEffect", function () {
  return $2a91c3126c559388$export$496315a1608d9602;
});

function $2a91c3126c559388$export$496315a1608d9602(effect, dependencies) {
  var isInitialMount = $5yePs$useRef(true);
  $5yePs$useEffect(function () {
    if (isInitialMount.current) isInitialMount.current = false;else effect(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

var $3e864361342e1b32$exports = {};
$parcel$export($3e864361342e1b32$exports, "useResizeObserver", function () {
  return $3e864361342e1b32$export$683480f191c0e3ea;
});

function $3e864361342e1b32$var$hasResizeObserver() {
  return typeof window.ResizeObserver !== 'undefined';
}

function $3e864361342e1b32$export$683480f191c0e3ea(options) {
  var ref = options.ref,
      onResize = options.onResize;
  $5yePs$useEffect(function () {
    var element = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!element) return;

    if (!$3e864361342e1b32$var$hasResizeObserver()) {
      window.addEventListener('resize', onResize, false);
      return function () {
        window.removeEventListener('resize', onResize, false);
      };
    } else {
      var resizeObserverInstance = new window.ResizeObserver(function (entries) {
        if (!entries.length) return;
        onResize();
      });
      resizeObserverInstance.observe(element);
      return function () {
        if (element) resizeObserverInstance.unobserve(element);
      };
    }
  }, [onResize, ref]);
}

var $0b7d7b0ae05ba812$exports = {};
$parcel$export($0b7d7b0ae05ba812$exports, "useSyncRef", function () {
  return $0b7d7b0ae05ba812$export$4debdb1a3f0fa79e;
});

function $0b7d7b0ae05ba812$export$4debdb1a3f0fa79e(context, ref) {
  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return function () {
        context.ref.current = null;
      };
    }
  }, [context, ref]);
}

var $0ac9283dcb18fed4$exports = {};
$parcel$export($0ac9283dcb18fed4$exports, "getScrollParent", function () {
  return $0ac9283dcb18fed4$export$cfa2225e87938781;
});

function $0ac9283dcb18fed4$export$cfa2225e87938781(node) {
  while (node && !$0ac9283dcb18fed4$var$isScrollable(node)) {
    node = node.parentElement;
  }

  return node || document.scrollingElement || document.documentElement;
}

function $0ac9283dcb18fed4$var$isScrollable(node) {
  var style = window.getComputedStyle(node);
  return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}

var $9ab7274bc657ab6d$exports = {};
$parcel$export($9ab7274bc657ab6d$exports, "useViewportSize", function () {
  return $9ab7274bc657ab6d$export$d699905dd57c73ca;
}); // @ts-ignore

var $9ab7274bc657ab6d$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;

function $9ab7274bc657ab6d$export$d699905dd57c73ca() {
  var _$5yePs$useState3 = $5yePs$useState(function () {
    return $9ab7274bc657ab6d$var$getViewportSize();
  }),
      _$5yePs$useState4 = _slicedToArray(_$5yePs$useState3, 2),
      size1 = _$5yePs$useState4[0],
      setSize = _$5yePs$useState4[1];

  $5yePs$useEffect(function () {
    // Use visualViewport api to track available height even on iOS virtual keyboard opening
    var onResize = function onResize() {
      setSize(function (size) {
        var newSize = $9ab7274bc657ab6d$var$getViewportSize();
        if (newSize.width === size.width && newSize.height === size.height) return size;
        return newSize;
      });
    };

    if (!$9ab7274bc657ab6d$var$visualViewport) window.addEventListener('resize', onResize);else $9ab7274bc657ab6d$var$visualViewport.addEventListener('resize', onResize);
    return function () {
      if (!$9ab7274bc657ab6d$var$visualViewport) window.removeEventListener('resize', onResize);else $9ab7274bc657ab6d$var$visualViewport.removeEventListener('resize', onResize);
    };
  }, []);
  return size1;
}

function $9ab7274bc657ab6d$var$getViewportSize() {
  return {
    width: ($9ab7274bc657ab6d$var$visualViewport === null || $9ab7274bc657ab6d$var$visualViewport === void 0 ? void 0 : $9ab7274bc657ab6d$var$visualViewport.width) || window.innerWidth,
    height: ($9ab7274bc657ab6d$var$visualViewport === null || $9ab7274bc657ab6d$var$visualViewport === void 0 ? void 0 : $9ab7274bc657ab6d$var$visualViewport.height) || window.innerHeight
  };
}

var $eea11ba5aff18b32$exports = {};
$parcel$export($eea11ba5aff18b32$exports, "useDescription", function () {
  return $eea11ba5aff18b32$export$f8aeda7b10753fa1;
});
var $eea11ba5aff18b32$var$descriptionId = 0;
var $eea11ba5aff18b32$var$descriptionNodes = new Map();

function $eea11ba5aff18b32$export$f8aeda7b10753fa1(description) {
  var _$5yePs$useState5 = $5yePs$useState(null),
      _$5yePs$useState6 = _slicedToArray(_$5yePs$useState5, 2),
      id1 = _$5yePs$useState6[0],
      setId = _$5yePs$useState6[1];

  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    if (!description) return;
    var desc = $eea11ba5aff18b32$var$descriptionNodes.get(description);

    if (!desc) {
      var id = "react-aria-description-".concat($eea11ba5aff18b32$var$descriptionId++);
      setId(id);
      var node = document.createElement('div');
      node.id = id;
      node.style.display = 'none';
      node.textContent = description;
      document.body.appendChild(node);
      desc = {
        refCount: 0,
        element: node
      };
      $eea11ba5aff18b32$var$descriptionNodes.set(description, desc);
    } else setId(desc.element.id);

    desc.refCount++;
    return function () {
      if (--desc.refCount === 0) {
        desc.element.remove();
        $eea11ba5aff18b32$var$descriptionNodes.delete(description);
      }
    };
  }, [description]);
  return {
    'aria-describedby': description ? id1 : undefined
  };
}

var $59df4c60f0011bf4$exports = {};
$parcel$export($59df4c60f0011bf4$exports, "isMac", function () {
  return $59df4c60f0011bf4$export$9ac100e40613ea10;
});
$parcel$export($59df4c60f0011bf4$exports, "isIPhone", function () {
  return $59df4c60f0011bf4$export$186c6964ca17d99;
});
$parcel$export($59df4c60f0011bf4$exports, "isIPad", function () {
  return $59df4c60f0011bf4$export$7bef049ce92e4224;
});
$parcel$export($59df4c60f0011bf4$exports, "isIOS", function () {
  return $59df4c60f0011bf4$export$fedb369cb70207f1;
});
$parcel$export($59df4c60f0011bf4$exports, "isAppleDevice", function () {
  return $59df4c60f0011bf4$export$e1865c3bedcd822b;
});
$parcel$export($59df4c60f0011bf4$exports, "isWebKit", function () {
  return $59df4c60f0011bf4$export$78551043582a6a98;
});
$parcel$export($59df4c60f0011bf4$exports, "isChrome", function () {
  return $59df4c60f0011bf4$export$6446a186d09e379e;
});
$parcel$export($59df4c60f0011bf4$exports, "isAndroid", function () {
  return $59df4c60f0011bf4$export$a11b0059900ceec8;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $59df4c60f0011bf4$var$testUserAgent(re) {
  return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator.userAgent) : false;
}

function $59df4c60f0011bf4$var$testPlatform(re) {
  return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator.platform) : false;
}

function $59df4c60f0011bf4$export$9ac100e40613ea10() {
  return $59df4c60f0011bf4$var$testPlatform(/^Mac/);
}

function $59df4c60f0011bf4$export$186c6964ca17d99() {
  return $59df4c60f0011bf4$var$testPlatform(/^iPhone/);
}

function $59df4c60f0011bf4$export$7bef049ce92e4224() {
  return $59df4c60f0011bf4$var$testPlatform(/^iPad/) || $59df4c60f0011bf4$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}

function $59df4c60f0011bf4$export$fedb369cb70207f1() {
  return $59df4c60f0011bf4$export$186c6964ca17d99() || $59df4c60f0011bf4$export$7bef049ce92e4224();
}

function $59df4c60f0011bf4$export$e1865c3bedcd822b() {
  return $59df4c60f0011bf4$export$9ac100e40613ea10() || $59df4c60f0011bf4$export$fedb369cb70207f1();
}

function $59df4c60f0011bf4$export$78551043582a6a98() {
  return $59df4c60f0011bf4$var$testUserAgent(/AppleWebKit/) && !$59df4c60f0011bf4$export$6446a186d09e379e();
}

function $59df4c60f0011bf4$export$6446a186d09e379e() {
  return $59df4c60f0011bf4$var$testUserAgent(/Chrome/);
}

function $59df4c60f0011bf4$export$a11b0059900ceec8() {
  return $59df4c60f0011bf4$var$testUserAgent(/Android/);
}

var $a3dca252611ad6b3$exports = {};
$parcel$export($a3dca252611ad6b3$exports, "useEvent", function () {
  return $a3dca252611ad6b3$export$90fc3a17d93f704c;
});

function $a3dca252611ad6b3$export$90fc3a17d93f704c(ref, event, handler1, options) {
  var _this = this;

  var handlerRef = $5yePs$useRef(handler1);
  handlerRef.current = handler1;
  var isDisabled = handler1 == null;
  $5yePs$useEffect(function () {
    if (isDisabled) return;
    var element = ref.current;

    var handler = function handler(e) {
      return handlerRef.current.call(_this, e);
    };

    element.addEventListener(event, handler, options);
    return function () {
      element.removeEventListener(event, handler, options);
    };
  }, [ref, event, options, isDisabled]);
}

var $71eec9ddbfb7f6c6$exports = {};
$parcel$export($71eec9ddbfb7f6c6$exports, "useValueEffect", function () {
  return $71eec9ddbfb7f6c6$export$14d238f342723f25;
});

function $71eec9ddbfb7f6c6$export$14d238f342723f25(defaultValue) {
  var _$5yePs$useState7 = $5yePs$useState(defaultValue),
      _$5yePs$useState8 = _slicedToArray(_$5yePs$useState7, 2),
      value = _$5yePs$useState8[0],
      setValue = _$5yePs$useState8[1];

  var valueRef = $5yePs$useRef(value);
  var effect = $5yePs$useRef(null);
  valueRef.current = value; // Store the function in a ref so we can always access the current version
  // which has the proper `value` in scope.

  var nextRef = $5yePs$useRef(null);

  nextRef.current = function () {
    // Run the generator to the next yield.
    var newValue = effect.current.next(); // If the generator is done, reset the effect.

    if (newValue.done) {
      effect.current = null;
      return;
    } // If the value is the same as the current value,
    // then continue to the next yield. Otherwise,
    // set the value in state and wait for the next layout effect.


    if (value === newValue.value) nextRef.current();else setValue(newValue.value);
  };

  $5ac25c9c8ba077b3$export$e5c5a5f917a5871c(function () {
    // If there is an effect currently running, continue to the next yield.
    if (effect.current) nextRef.current();
  });
  var queue = $5yePs$useCallback(function (fn) {
    effect.current = fn(valueRef.current);
    nextRef.current();
  }, [effect, nextRef]);
  return [value, queue];
}

var $f2c8e5a8b491ced1$exports = {};
$parcel$export($f2c8e5a8b491ced1$exports, "scrollIntoView", function () {
  return $f2c8e5a8b491ced1$export$53a0910f038337bd;
});

function $f2c8e5a8b491ced1$export$53a0910f038337bd(scrollView, element) {
  var offsetX = $f2c8e5a8b491ced1$var$relativeOffset(scrollView, element, 'left');
  var offsetY = $f2c8e5a8b491ced1$var$relativeOffset(scrollView, element, 'top');
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  var x = scrollView.scrollLeft;
  var y = scrollView.scrollTop;
  var maxX = x + scrollView.offsetWidth;
  var maxY = y + scrollView.offsetHeight;
  if (offsetX <= x) x = offsetX;else if (offsetX + width > maxX) x += offsetX + width - maxX;
  if (offsetY <= y) y = offsetY;else if (offsetY + height > maxY) y += offsetY + height - maxY;
  scrollView.scrollLeft = x;
  scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */


function $f2c8e5a8b491ced1$var$relativeOffset(ancestor, child, axis) {
  var prop = axis === 'left' ? 'offsetLeft' : 'offsetTop';
  var sum = 0;

  while (child.offsetParent) {
    sum += child[prop];
    if (child.offsetParent === ancestor) break;else if (child.offsetParent.contains(ancestor)) {
      // If the ancestor is not `position:relative`, then we stop at
      // _its_ offset parent, and we subtract off _its_ offset, so that
      // we end up with the proper offset from child to ancestor.
      sum -= ancestor[prop];
      break;
    }
    child = child.offsetParent;
  }

  return sum;
}

export { $5b01a7ee7dba2d86$export$f680877a34711e37 as useId, $5b01a7ee7dba2d86$export$cd8c9cb68f842629 as mergeIds, $5b01a7ee7dba2d86$export$b4cc09c592e8fdb8 as useSlotId, $2a5eca539fe56811$export$e08e3b67e392101e as chain, $c42fb2a2f22e1846$export$9d1611c77c2fe928 as mergeProps, $f3859cd41d3e5b7d$export$457c3d6518dd4c6f as filterDOMProps, $1b46e2787874cd75$export$de79e2c695e052f3 as focusWithoutScrolling, $fbd35a31e994df41$export$622cea445a1c5b7d as getOffset, $691ac3ad1af88e64$re_export$clamp as clamp, $691ac3ad1af88e64$re_export$snapValueToStep as snapValueToStep, $51de12ccb2f75a87$export$24490316f764c430 as runAfterTransition, $b8aeddd69b238bce$export$7bbed75feba39706 as useDrag1D, $ce924e419b398d4c$export$4eaf04e54aa8eed6 as useGlobalListeners, $71a2c5844f2b60a4$export$d6875122194c7b44 as useLabels, $a235e7a487a1e81a$export$4338b53315abf666 as useObjectRef, $2a91c3126c559388$export$496315a1608d9602 as useUpdateEffect, $5ac25c9c8ba077b3$export$e5c5a5f917a5871c as useLayoutEffect, $3e864361342e1b32$export$683480f191c0e3ea as useResizeObserver, $0b7d7b0ae05ba812$export$4debdb1a3f0fa79e as useSyncRef, $0ac9283dcb18fed4$export$cfa2225e87938781 as getScrollParent, $9ab7274bc657ab6d$export$d699905dd57c73ca as useViewportSize, $eea11ba5aff18b32$export$f8aeda7b10753fa1 as useDescription, $59df4c60f0011bf4$export$9ac100e40613ea10 as isMac, $59df4c60f0011bf4$export$186c6964ca17d99 as isIPhone, $59df4c60f0011bf4$export$7bef049ce92e4224 as isIPad, $59df4c60f0011bf4$export$fedb369cb70207f1 as isIOS, $59df4c60f0011bf4$export$e1865c3bedcd822b as isAppleDevice, $59df4c60f0011bf4$export$78551043582a6a98 as isWebKit, $59df4c60f0011bf4$export$6446a186d09e379e as isChrome, $59df4c60f0011bf4$export$a11b0059900ceec8 as isAndroid, $a3dca252611ad6b3$export$90fc3a17d93f704c as useEvent, $71eec9ddbfb7f6c6$export$14d238f342723f25 as useValueEffect, $f2c8e5a8b491ced1$export$53a0910f038337bd as scrollIntoView };